<template>
    <div class="mt-12">
        <a class="anchor" :name="`${object.method}${object.path}`" :id="`${object.method}${object.path}`" />

        <h2>{{ object.summary }}</h2>

        <div class="flex items-center gap-x-3" v-if="object.method">
            <span class="font-mono text-[0.625rem] font-semibold leading-6 rounded-md px-1.5 ring-1 ring-inset"
                :class="COLOURS[object.method]">
                {{ object.method?.toUpperCase() }}
            </span>
            <!-- <span class="h-0.5 w-0.5 rounded-full bg-zinc-300 dark:bg-zinc-600"></span> -->
            <span class="font-mono text-xs text-medium-gray overflow-x-hidden">{{ object.path }}</span>

            <span class="font-semibold rounded px-1.5 ring-1 text-[0.625rem]" v-if="!object.security"
                title="No  authentication is required for this API call">NO AUTH</span>
        </div>

        <p v-if="object.description" class="py-4 text-sm">
            {{ object.description }}
        </p>

        <div v-if="object.summary?.startsWith('List')">
            <IntegrationSupport :object="object.path?.split('/')[3] || ''" prefix="list"
                :cat="object.path?.split('/')[1] || ''" />
        </div>

        <div v-if="object.path?.startsWith('/enrich')">
            <IntegrationSupport :object="object.path?.split('/')[3] || ''" prefix="search"
                :cat="object.path?.split('/')[1] || ''" />
        </div>

        <div class="flex flex-wrap lg:justify-left">
            <div class="w-full lg:w-2/3">
                <ApiFields v-if="object.parameters?.length && object.parameters.find((p) => p.in !== 'body')"
                    title="Parameters" :fields="(object.parameters as any)" :form="apiexplorer ? data : undefined"
                    @update:form="(_data) => (data = _data)" :connections="connections" />

                <ApiFields
                    v-if="!bodyDefinition && object.parameters?.length && object.parameters.find((p) => p.in === 'body')"
                    :body="true" title="Payload" :fields="(object.parameters as any)"
                    :form="apiexplorer ? data : undefined" @update:form="(_data) => (data = _data)"
                    :connections="connections" />

                <div v-if="bodyDefinition">
                    <h3>Payload</h3>
                    <div class="rounded-lg w-full">
                        <div class="properties">
                            <!-- <code> -->
                            <a :href="`#${object.tags?.[0]}_object_${bodyDefinition?.name?.toLowerCase()}`"
                                class="text-sm">
                                {{ bodyDefinition?.name }}
                            </a>
                            <!-- </code> -->
                            <span class="break-normal ml-2">
                                <em v-if="bodyDefinition.array">array</em>
                            </span>
                        </div>
                        <div v-if="apiexplorer" class="mx-6 my-2">
                            <textarea v-model="data._body"
                                class="text-xs font-mono border rounded px-2 py-1 w-full h-20"
                                placeholder="JSON data"></textarea>
                        </div>
                    </div>
                </div>

                <div v-if="object.responses['200']?.schema?.type">
                    <h3>Returns</h3>
                    <div class="rounded-lg w-full">
                        <div class="properties">
                            <span class="break-normal">
                                <em>{{ object.responses['200']?.schema?.type }}</em>
                            </span>
                            <p v-if="object.responses['200']?.schema?.description" class="text-sm pr-2 mt-1 mb-0"
                                style="margin-bottom: 0">
                                {{ object.responses['200']?.schema?.description }}
                            </p>
                        </div>
                    </div>
                </div>

                <div v-if="object.responses['200']?.schema.$ref">
                    <h3>Returns</h3>
                    <div class="rounded-lg w-full" v-if="definition && definition.type === 'object'">
                        <div class="properties">
                            <!-- <code> -->
                            <a :href="`#${object.tags?.[0]}_object_${definition?.name?.toLowerCase()}`" class="text-sm">
                                {{ definition?.name }}
                            </a>
                            <!-- </code> -->
                            <span class="break-normal ml-2">
                                <em v-if="definition.array">array</em>
                            </span>
                        </div>
                    </div>
                </div>

                <!-- <div v-if="INTEGRATIONS.filter((i) => i.feature_support[featureSupport(object.operationId)]).length">
                    <h3>Supoprted Integrations</h3>

                    <div class="flex flex-wrap gap-2">
                        <Integration
                            :just-image="true"
                            :integration="int"
                            v-for="int in INTEGRATIONS.filter((i) => i.feature_support[featureSupport(object.operationId)])"
                        />
                    </div>
                </div> -->
                <!-- <div v-else>
                    {{ object.operationId }} /
                    {{ featureSupport(object.operationId) }}
                </div> -->
            </div>

            <div class="w-full lg:w-1/3" v-if="object.path !== '/unified/integration/auth/{workspace_id}/{integration_type}' &&
                object.path !== '/unified/integration/login/{workspace_id}/{integration_type}'
            ">
                <CodeBlock :object="object" class="lg:ml-8" />

                <div class="lg:ml-8 mt-8 shadow-lg rounded-lg bg-[var(--dark-gray)]">
                    <div
                        class="uppercase px-4 rounded-t-lg pb-1 pt-1 font-semibold border-b-2 text-[var(--light-gray)] text-sm">
                        API
                        Explorer</div>

                    <div class="px-4 py-4">
                        <button v-if="!apiexplorer" class="btn btn-primary btn-small mt-1 mb-1" @click="
                            apiexplorer = true;
                        results = '';
                        error = '';
                        ">
                            Show
                        </button>

                        <button v-if="apiexplorer" class="btn btn-primary btn-small mr-4 mt-1 mb-1"
                            @click="fetchData(undefined, true)">Call Mock API</button>
                        <button v-if="apiexplorer && user && object.path?.includes('/unified/')"
                            class="btn btn-primary btn-small mr-4 mt-1 mb-1" @click="fetchData(undefined)">
                            Call API
                        </button>
                        <DropdownButton class="mr-4"
                            v-if="dropdown.options?.length && apiexplorer && user && !object.path?.includes('/unified/')"
                            :item="dropdown" :select="(id) => fetchData(id)" />

                        <button v-if="apiexplorer" class="btn btn-primary btn-small mr-4 mt-1 mb-1"
                            @click="apiexplorer = false">Hide</button>

                        <icon name="material-symbols:refresh-rounded" v-if="loading"
                            class="animate-spin text-3xl mt-1 mb-1" />
                    </div>

                    <div v-if="apiexplorer && results" style="width: auto"
                        class="text-xs font-mono p-4 text-primary-green max-h-80 overflow-y-auto pb-4 border-t-2 border-[var(--white)]">
                        <pre class="overflow-x-hidden max-w-xl">{{ results }}</pre>
                    </div>

                    <div v-if="apiexplorer && error"
                        class="bg-[var(--primary-red)] py-3 px-3 text-light-gray text-sm font-semibold border-t-2 border-[var(--white)] rounded-b-lg">
                        <Icon name="material-symbols:warning-outline" class="text-2xl mr-2" />
                        {{ error }}
                    </div>
                </div>
                <!-- <ApiEndpointExplorerVue :object="object" /> -->
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { type PropType } from 'vue';
import { type IConnection, type IIntegration, type IUser } from '~~/models/Unified';
import { type IDropdownButton, type SwaggerDefinition, type SwaggerField, type SwaggerPath } from '~~/services/common';
import { getDefinition } from '~~/services/swagger';
import { useUserSession } from '~~/store/user';
import DropdownButton from '~~/components/DropdownButton.vue';
import { _call } from '~~/services/api';
import { INTEGRATIONS } from '~~/services/integrations';

export function splitCamelCase(str: string): string[] {
    const regex = /(?=[A-Z])/;
    return str.split(regex);
}

// import { TIntegrationFeaturesType } from '~~/models/Unified';
import TIntegrationSupport from './IntegrationSupport.vue';
// import { PLATFORMS, PLATFORM, setPlatform } from '~~/models/common';
// import { usePlatformSession } from '~~/store/platform';
// import ApiEndpointExplorerVue from '~~/components/ApiEndpointExplorer.vue';

export default {
    components: { DropdownButton, TIntegrationSupport },
    props: {
        object: {
            type: Object as PropType<SwaggerPath>,
            required: true,
        },
    },
    data() {
        return {
            INTEGRATIONS: INTEGRATIONS as IIntegration[],
            apiexplorer: false,
            user: undefined as IUser | undefined,
            dropdown: { name: 'Call API' } as IDropdownButton,
            data: {} as any,
            loading: false,
            results: '',
            error: '',
            connections: [] as IConnection[],
            // PLATFORM: usePlatformSession().getPlatform(),
            // PLATFORMS,
            // dropdownPopoverShow: false,
            // copied: false,
            SUPPORT: {
                'get/accounting/{connection_id}/customer': 'accountingCustomerList',
                'get/accounting/{connection_id}/invoice': 'accountingInvoiceList',
                'get/accounting/{connection_id}/payment': 'accountingPaymentList',

                'get/crm/{connection_id}/contact': 'crmContactList',
                'get/crm/{connection_id}/company': 'crmCompanyList',
                'get/crm/{connection_id}/deal': 'crmDealList',
                'get/crm/{connection_id}/event': 'crmEventList',
                'get/crm/{connection_id}/file': 'crmFileList',
                'get/crm/{connection_id}/team': 'crmTeamList',
                'get/crm/{connection_id}/lead': 'crmLeadList',
                'get/crm/{connection_id}/user': 'crmUserList',
                'get/crm/{connection_id}/pipeline': 'crmPipelineList',

                'get/enrich/{connection_id}/company': 'enrichCompanySearch',
                'get/enrich/{connection_id}/person': 'enrichPersonSearch',

                'get/martech/{connection_id}/list': 'martechListList',
                'get/martech/{connection_id}/{list_id}/member': 'martechMemberList',

                'get/ticketing/{connection_id}/agent': 'ticketAgentList',
                'get/ticketing/{connection_id}/customer': 'ticketCustomerList',
                'get/ticketing/{connection_id}/ticket': 'ticketTicketList',
                'get/ticketing/{connection_id}/note': 'ticketNoteList',

                'get/uc/{connection_id}/agent': 'ucAgentList',
                'get/uc/{connection_id}/contact': 'ucContactList',
                'get/uc/{connection_id}/call': 'ucCallList',

                'get/ats/{connection_id}/candidate': 'atsCandidateList',
                'get/ats/{connection_id}/job': 'atsJobList',
                'get/ats/{connection_id}/interview': 'atsInterviewList',
                'get/ats/{connection_id}/scorecard': 'atsScorecardList',
                'get/ats/{connection_id}/document': 'atsDocumentList',
                'get/ats/{connection_id}/application': 'atsApplicationList',
                'get/ats/{connection_id}/applicationstatus': 'atsApplicationstatusList',

                'get/hris/{connection_id}/employee': 'hrisEmployeeList',
                'get/hris/{connection_id}/group': 'hrisGroupList',
            } as { [path in string]?: string },
            COLOURS: {
                get: 'ring-emerald-300 bg-emerald-400/10 text-emerald-500',
                put: 'ring-amber-300 bg-amber-400/10 text-amber-500',
                delete: 'ring-rose-200 bg-rose-50 text-primary-red',
                post: 'ring-sky-300 bg-sky-400/10 text-sky-500',
            } as any,
            definition: this.object?.responses['200']?.schema?.$ref ? getDefinition(this.object?.responses['200']?.schema?.$ref) : undefined,
            body: this.object.parameters?.length ? this.object.parameters.find((p) => p.in === 'body') : undefined,
            bodyDefinition: undefined as SwaggerDefinition | SwaggerField | undefined,
        };
    },
    methods: {
        // getCrmConnection_idTeam => crmTeamList
        // postCrmConnection_idTeam => crmTeamCreate
        // getCrmConnection_idTeamId => crmTeamGet
        // putCrmConnection_idTeamId => crmTeamUpdate
        // deleteCrmConnection_idTeamId => crmTeamDelete
        // putCrmConnection_idCompanyIdDealDeal_id => crmCompanyAddDeal
        // deleteCrmConnection_idCompanyIdDealDeal_id => crmCompanyRemoveDeal
        featureSupport(id: string) {
            const parts = splitCamelCase(id);

            // if (parts[2] !== 'Connection_id') {
            //     console.error(id, parts);
            // }

            const MAP: any = {
                get: 'Get',
                post: 'Create',
                put: 'Update',
                delete: 'Remove',
            };

            let result = `${parts[1].toLowerCase()}${parts[3]}`;

            if (parts[0] === 'put' && parts.length === 7) {
                result += `Add${parts[5]}`;
            } else if (parts[0] === 'delete' && parts.length === 7) {
                result += `Remove${parts[5]}`;
            } else if (parts[0] === 'get') {
                if (parts.length === 5) {
                    result += 'Get';
                } else {
                    result += 'List';
                }
            } else {
                result += MAP[parts[0]];
            }
            // console.log(id, result);
            return result;
        },
        async fetchData(connection_id?: string, mock = false) {
            this.loading = true;
            this.results = '';
            this.error = '';

            let url = this.object.path
                ?.replace('{connection_id}', connection_id || '5de520f96e439b002043d8dc')
                .replace('/connection/{id}', `/connection/${connection_id || '5de520f96e439b002043d8dc'}`)
                .replace('{workspace_id}', this.user?.workspace_id!);
            (this.object.parameters || []).forEach((p) => {
                if (p.in === 'path') {
                    url = url?.replace(`{${p.name}}`, this.data[p.name] || '5de520f96e439b002043d8dc');
                    if (p.name === 'path') {
                        url = url?.replace(`{path*}`, this.data[p.name] || '5de520f96e439b002043d8dc');
                    }
                }
            });

            console.log('url', mock, url, this.object.path);
            try {
                const params: any = {};
                (this.object.parameters || [])
                    .filter((p) => p.in === 'query')
                    .forEach((p) => (params[p.name] = Array.isArray(this.data[p.name]) ? (this.data[p.name] as string[]).join(',') : this.data[p.name]));

                // console.log(
                //     'params',
                //     (this.endpoint?.object.parameters || []).filter((p) => p.in === 'query')
                // );
                // console.log('cats', this.form.categories);

                let body = undefined as any | undefined;
                if (this.data._body) {
                    try {
                        body = JSON.parse(this.data._body);
                    } catch {
                        this.error = 'Invalid JSON';
                    }
                }

                if (!this.error) {
                    const results = await _call(this.object.method || 'get', url!, body, params, mock);
                    console.log('results', results);

                    this.results = JSON.stringify(results, null, 2);
                }
            } catch (err: any) {
                console.error(err);
                this.error = err.response?.data?.message || err.code;
            }
            this.loading = false;
        },
        // setPlatform(p: string) {
        //     console.log('set', p);
        //     usePlatformSession().setPlatform(p);
        //     // this.PLATFORM = p;
        //     this.dropdownPopoverShow = false;
        // },
        // copy() {
        //     this.copied = true;
        //     setTimeout(() => {
        //         this.copied = false;
        //     }, 2000);
        // },
    },
    async mounted() {
        // console.log('api-object.start');
        this.user = await useUserSession().getUser();
        this.connections = await useUserSession().fetchConnections();

        this.dropdown.options = this.connections
            .filter((c) => c.categories.includes(this.object?.tags![0]))
            .map((c) => {
                return { name: c.integration_type, value: c.id };
            });

        // console.log('api-object.end', this.object?.tags?.[0], this.dropdown.options.length);

        this.bodyDefinition = this.body?.schema?.$ref ? getDefinition(this.body?.schema?.$ref) : undefined;

        // console.log('object', this.object);
    },
};
</script>